import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switch-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "switch-tips" }, " 只看减免购置税 ", -1)
const _hoisted_3 = { class: "icon-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_switch = _resolveComponent("van-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_switch, {
      modelValue: _ctx.checked,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event)),
      "active-color": _ctx.activeColor,
      "inactive-color": "#dcdee0",
      onChange: _ctx.handleSwitch,
      size: "20px",
      style: {"width":"65px"}
    }, {
      node: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_icon, {
            name: _ctx.checked ? 'success' : 'cross',
            color: _ctx.activeColor
          }, null, 8, ["name", "color"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "active-color", "onChange"])
  ]))
}